<template >
  <div>
    <div
      class="row m-0 fixed-bottom time rtl"
      style="
        height: 50px;
        max-width: 590px;
        margin: 0 auto !important;
        z-index: 2;
      "
    >
      <div class="col-2 text-center errorsTimeMap pl-0">
        {{ errorNumber }}
        <span id="erreurs">{{ lang }}{{ translation.mistakes }}</span>
      </div>
      <div class="col-3 text-center errorsTimeMap pl-1">
        {{ pointNumForEvolution }}/{{ Object.values(pointsArrayOrder).length }}
        <span id="evolution">התקדמות</span>
      </div>
      <div class="col-5 text-center errorsTimeMap pr-0">
        {{ secondsToTime }}
        <span id="runningTime">{{ translation.runningTime }}</span>
      </div>
      <div
        class="col-2 text-center errorsTimeMap pr-0"
        @click="slideMapInn"
        style="color: rgb(117, 185, 172)"
      >
        <span id="carte">{{ translation.map }}</span>
        <svg
          class="bi bi-map"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M15.817.613A.5.5 0 0116 1v13a.5.5 0 01-.402.49l-5 1a.502.502 0 01-.196 0L5.5 14.51l-4.902.98A.5.5 0 010 15V2a.5.5 0 01.402-.49l5-1a.5.5 0 01.196 0l4.902.98 4.902-.98a.5.5 0 01.415.103zM10 2.41l-4-.8v11.98l4 .8V2.41zm1 11.98l4-.8V1.61l-4 .8v11.98zm-6-.8V1.61l-4 .8v11.98l4-.8z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <!-- <div
      v-if="gameParameters.anniversary === true"
      class="m-2 p-2 border rounded bg-white"
    >
      {{ allLetters }}
    </div> -->

    <div
      v-if="rowPhotoMissingWord"
      style="
        display: block;
        margin: 0px;
        padding: 0px;
        min-height: calc(100vh - 150px);
        margin-bottom: 55px;
      "
      class="mt-4 container d-flex"
    >
      <div class="row p-0 m-0" style="max-width: 590px">
        <div
          class="row align-items-center justify-content-center align-self-center m-0 p-0"
          style="min-height: 20%"
        >
          <div class="col-12 p-0 m-0">
            <p class="text-center px-3 h4">{{ translation.pointNumber }}</p>
          </div>
          <div class="font-weight-bold h4 text-center pointNumber my-3">
            {{
              Object.values(points)[pointsArrayOrder[pointNum] - 1].pointNumber
            }}
          </div>
          <div class="col-12 p-0 m-0">
            <p class="px-2 text-center">{{ translation.goThere }}</p>
          </div>
        </div>
        <div
          class="row align-items-center justify-content-center align-self-center m-0 p-0"
          style="min-height: 40%"
        >
          <img id="imgUrl" class="align-center" width="95%" :src="getImgUrl" />
        </div>
        <!-- <div class="col-12" style="margin-bottom: -8px">
          <p class="text-center mt-3 mb-0 font-weight-bold">
            נא לרשום את המילה ללא גרש
          </p>
        </div> -->

        <div
          class="row align-items-center justify-content-center align-self-center m-0 p-0"
          style="min-height: 15%; width: 100vw; margin-bottom: 50px !important"
        >
          <div
            class="col-2 pl-0"
            style="
              font-size: 40px;
              color: rgb(117, 185, 172);
              padding: 0px;
              margin-top: 17px;
            "
          >
            <svg
              class="bi bi-arrow-right-circle-fill float-right"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              @click="checkMissingWord"
            >
              <path
                fill-rule="evenodd"
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5.5a.5.5 0 0 0 0-1H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5z"
              />
            </svg>
          </div>
          <div class="mt-3 col-8 pl-1 pr-1">
            <input
              class="center fullWidth text-center"
              aria-describedby="missingWordAnswer"
              :placeholder="translationMissingWord"
              name="missingWordAnswer"
              label="missingWordAnswer"
              id="missingWordAnswer"
              v-model="missingWordAnswer"
              required
              style="
                border-radius: 36px;
                height: 50px;
                border: 1px rgb(117, 185, 172) solid;
                width: 100%;
              "
            />
          </div>
          <div
            class="col-2 pl-2"
            style="font-size: 30px; color: rgb(117, 185, 172); margin-top: 11px"
            @click="showAlertSkipPoint"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              class="bi bi-skip-backward-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z"
              />
            </svg>
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              class="bi bi-question-diamond"
              viewBox="0 0 16 16"
            >
              <path
                d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"
              />
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
              />
            </svg> -->
          </div>
        </div>
      </div>
    </div>

    <div
      id="questionDiv"
      v-if="rowPhotoMissingWord === false"
      style="display: block"
      align="center"
    >
      <div class="my-5 px-1">
        <p class="question px-3 text-right rtl">
          {{ questionSuffled[questionNumber].question }}
        </p>
      </div>
      <div class="mb-5 rtl">
        <div :key="answer.id" v-for="answer in getAnswerArray">
          <!-- <button
            class="fullWidth colorBtn btn font-weight-bold mb-3"
            style="background-color: #4f9e2c"
            @click="checkAnswer(answer)"
          > -->
          <button
            class="fullWidth colorBtn btn font-weight-bold mb-3"
            style="background-color: rgb(117, 185, 172)"
            :disabled="answered"
            @click="checkAnswer(answer)"
          >
            {{ answer }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showPointInformation === true && rowPhotoMissingWord === false"
      class="over"
    >
      <div class="myModal p-3 mb-2 modalInformationPoint rtl">
        <!-- <div class="container h-100 d-flex"> -->
        <div class="row mt-4">
          <!-- <div class="col-12 d-flex align-items-start">
              <div class="mb-4 text-right rtl">
                <strong>{{ translation.didYouKnow }}</strong>
              </div>
            </div> -->

          <!-- PLAY THE AUDIO FILE -->
          <div class="col-12 align-self-center text-right rtl">
            <div class="mt-4 mb-4">
              <!-- <audio
                  v-if="
                    Object.values(this.points)[
                      this.pointsArrayOrder[this.pointNum] - 1
                    ].audioUrl
                  "
                  id="audio"
                  controls
                  autoplay
                >
                  <source :src="audioSrc" type="audio/mp3" />
                </audio> -->
              <audio v-if="arrayOfAudioUrl" id="audio" controls autoplay>
                <source
                  :src="arrayOfAudioUrl[this.pointNum]"
                  type="audio/mp3"
                />
              </audio>
            </div>
            <!-- SHOW THE WRITTEN INFORMATION -->
            <div style="white-space: pre-line; font-size: 18px">
              <!-- {{ newInformationPointString }} -->
              {{ arrayOfPointInfo[this.pointNum] }}
            </div>
          </div>
          <div class="col-12 d-flex align-items-end">
            <button
              v-if="showButtonInfoScreen"
              class="mainButton btn font-weight-bold mt-3 rtl"
              style="background-color: rgb(119, 190, 87); margin-bottom: 50px"
              @click="fadeInDiv"
            >
              {{ translation.goToQuestions }}
            </button>
            <button
              v-else
              class="mainButton btn font-weight-bold mt-3 rtl"
              style="background-color: rgb(119, 190, 87); margin-bottom: 50px"
              disabled
            >
              {{ translation.goToQuestions }}
            </button>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <div v-if="alertSkipPoint" class="over">
      <div class="myModal p-4 mb-5 red container d-flex">
        <div class="row justify-content-center align-self-center">
          <div class="h5 mb-4 text-center col-12 rtl">
            {{ translation.skipPointBeware }}
          </div>
          <div class="col-6">
            <div
              class="font-weight-bold h6 text-center"
              style="width: 100%"
              @click="
                skipPoint();
                hideImageQuestion();
              "
            >
              {{ translation.skipPoint }}
            </div>
          </div>
          <div class="col-6">
            <div
              class="font-weight-bold h6 text-center"
              style="
                width: 100%;
                padding-top: 9px;
                color: red;
                background: white;
                height: 38px;
                border-radius: 30px;
              "
              @click="alertSkipPoint = false"
            >
              {{ translation.back }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogCorrectAnswer" class="over">
      <!-- <div
        class="myModal p-4 mb-5 green container d-flex"
        @click="hideImageQuestion"
      > -->
      <div
        class="myModal p-4 mb-5 container d-flex"
        style="background: #2fcf17"
        @click="hideImageQuestion"
      >
        <div class="row justify-content-center align-self-center">
          <audio id="audio" controls autoplay style="display: none">
            <source src="../../static/sounds/applause.mp3" type="audio/mp3" />
          </audio>
          <div
            class="h2 mb-4 text-center col-12 rtl"
            style="font-family: 'noot'"
          >
            {{ translation.wellDone }}
          </div>
          <div class="mb-4 text-center h5 col-12 rtl">
            {{ translation.correctAnswer }}
          </div>
          <div class="col-12">
            <div
              class="fullWidth font-weight-bold h4 text-center rtl"
              style="background-color: #2fcf17; width: 100%"
            >
              {{ translation.continue }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogWrongAnswer" class="over">
      <div
        class="myModal p-4 mb-5 red container d-flex"
        @click="dialogWrongAnswer = false; missingWordAnswer = ''; answered = false"
      >
        <div
          class="row justify-content-center align-self-center"
          style="color: white; background: #d41a1b"
        >
          <div
            class="col-12 h2 mb-4 text-center rtl"
            style="font-family: 'noot'"
          >
            הופאהה!
          </div>
          <div class="col-12 mb-4 text-center rtl">
            {{ translation.wrongAnswer }}
          </div>
          <audio id="audio" controls autoplay style="display: none">
            <source src="../../static/sounds/boo.mp3" type="audio/mp3" />
          </audio>

          <div
            class="fullWidth font-weight-bold h3 text-center rtl"
            style="width: 100%"
          >
            {{ translation.tryAgain }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="showLastDialog" class="over container d-flex">
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div
        class="myModal p-2 rgb(117, 185, 172) d-flex row justify-content-center align-self-center align-items-center mt-0"
        style="background: #3939f3"
        @click="showResults"
      >
        <audio id="audio" controls loop autoplay style="display: none">
          <source src="../../static/sounds/Champions.mp3" type="audio/mp3" />
        </audio>
        <div class="h4 p-2 col-12 text-center rtl" style="font-family: 'noot'">
          כל הכבוד {{ userName }}!
        </div>
        <div class="p-2 col-12 text-right rtl">
          {{ translation.visitOf }}
          <!-- {{ gameParameters.navigationName.toUpperCase() }}! -->
        </div>
        <div class="border border-white px-4 py-2">
          <div class="p-2 col-12 font-weight-bold text-right rtl">
            {{ translation.yourResults }}
          </div>
          <div class="p-2 col-12 font-italic text-right rtl">
            {{ translation.errorNumber }} {{ errorNumber }}
          </div>
          <div class="p-2 col-12 font-italic text-right rtl">
            {{ translation.totalTime }} {{ gameSecondToTime }}
          </div>
        </div>

        <div class="p-2 col-12 text-right rtl">
          {{ translation.goToRanking }}
        </div>
      </div>
    </div>

    <div id="map">
      <span @click="removeMap" class="removeMapButton">
        <button
          type="button"
          class="close"
          aria-label="Close"
          style="font-size: 48px; color: red"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <!-- <svg
          class="bi bi-x-circle"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
          />
          <path
            fill-rule="evenodd"
            d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
          />
          <path
            fill-rule="evenodd"
            d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
          />
        </svg> -->
      </span>
      <div
        v-if="showCurrentPositionButton"
        @click="showCurrentPosition"
        class="currentPosButton"
      >
        <!-- איפה'ני? -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25px"
          height="25px"
          fill="currentColor"
          class="bi bi-geo-alt-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
          />
        </svg>
      </div>
      <div v-else @click="stopLocationUpdates" class="currentPosButton">
        הסתר מיקום
      </div>
      <GmapMap
        :center="{
          lat: Number(mapParameters.lat),
          lng: Number(mapParameters.lng),
        }"
        :zoom="Number(mapParameters.zoom)"
        map-type-id="roadmap"
        :tilt="0"
        style="width: 100vw; height: 100vh"
        :styles="myMapStyle"
        :options="{
          zoomControl: false,
          mapTypeControl: true,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: false,
          disableDefaultUi: false,
        }"
      >
        <GmapMarker
          style="margin-right: 10px !important"
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          :label="{ text: `${index + 1}`, color: 'white', fontSize: '9px' }"
          @click="center = m.position"
        />
        <GmapMarker
          v-if="showPosMarker"
          style="
            margin-right: 10px !important;
            height: 50px !important;
            width: 50px !important;
          "
          :clickable="true"
          @click="center = m.position"
          :position="myCurrentPosition"
          :icon="iconImage"
        />
      </GmapMap>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

export default {
  data() {
    return {
      alertSkipPoint: false,
      imageUrl: "",
      showPosMarker: false,
      showButtonInfoScreen: false,
      iconImage: {
        url: require("../../static/img/circle.png"),
      },
      watchPositionId: null,
      position: "Position",
      showCurrentPositionButton: true,
      myCurrentPosition: "",
      myMapStyle: {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      firstQuestion: 1,
      showPointInformation: false,
      secondsToTime: "00:00:00",
      gameSecondToTime: "",
      totalSeconds: 0,
      startTime: Date.now(),
      endTime: "",
      showMap: false,
      showLastDialog: false,
      key: "",
      questiomMultipleChoices: true,
      rowPhotoMissingWord: true,
      dialogWrongAnswer: false,
      dialogCorrectAnswer: false,
      answered: false,
      missingWordAnswer: "",
      loading: false,
      src: "",
      timeNow: "",
      questionNumber: -1,
      // questionNumber: 0,

      errorNumber: 0,
      pointNum: 0,
      pointNumForEvolution: 1,
      letter: "",
      allLetters: "",
      gameTimeInSecond: "",
      userKey: "",
      translationMissingWord: "Mot manquant sur l'image",
      translation: {
        mistakes: "Erreurs",
        runningTime: "Temps écoulé",
        map: "Carte",
        pointNumber: "Sur la carte, repérez le nº",
        goThere:
          "Rendez-vous sur place et trouvez l'inscription qui se trouve sur l'image ci-dessous.",
        didYouKnow: "Le saviez-vous?",
        goToQuestions: "Allons aux questions!",
        wellDone: "Bien joué!",
        correctAnswer: "C'est une bonne réponse!",
        continue: "Allez! On continue",
        wrongAnswer: "Ce n'est pas la bonne réponse.",
        tryAgain: "Essayons encore!",
        visitOf: "Nous espérons que vous avez apprécié votre visite de",
        yourResults: "Vos résultats sont:",
        errorNumber: "Nombre d'erreur:",
        totalTime: "Temps total:",
        goToRanking:
          "Avant de partir, vous pouvez aller jeter un coup d'oeil sur les résultats et voir en quelle positon vous êtes arrivés!",
      },
    };
  },
  mounted() {
    console.log("Date.now()", Date.now());
    console.log("this.startTime", this.startTime);

    if (this.gameParameters) {
      console.log("ok");
    } else {
      console.log("bug");
      this.reopenGame();
    }
    this.userKey = localStorage.getItem("userKey");
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    this.countSeconds();
    if (localStorage.getItem("questionNumber")) {
      if (localStorage.getItem("pointNumberOuchui")) {
        this.pointNum = localStorage.getItem("pointNumberOuchui");
        this.pointNumForEvolution = localStorage.getItem(
          "pointNumForEvolutionOuchui"
        );
      } else {
        this.pointNum = 0;
        this.pointNumForEvolution = 1;
      }
      this.startTime = localStorage.getItem("startTimeOuchui");
      if (localStorage.getItem("errorNumber")) {
        this.errorNumber = localStorage.getItem("errorNumber");
      } else {
        this.errorNumber = 0;
      }
      this.questionNumber = JSON.parse(localStorage.getItem("questionNumber"));
      this.firstQuestion = localStorage.getItem("firstQuestion");
      this.rowPhotoMissingWord = JSON.parse(
        localStorage.getItem("rowPhotoMissingWord")
      );
      console.log(
        "[mounted] this.showPointInformation",
        this.showPointInformation
      );
      console.log(
        "[mounted] this.rowPhotoMissingWord",
        this.rowPhotoMissingWord
      );
    }
    // Show loading animation.
    setTimeout(function () {
      // var playPromise = document.getElementById("audio").play();
      var playPromise = document.querySelector("audio");
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {})
          .catch((error) => {
            // Auto-play was prevented
            console.log("errrrrrrorrrr playing");
            // Show paused UI.
          });
      }
    }, 500);
    // }
    // this.$store.dispatch("fetchAudio", this.gameParameters.navigationName);
  },
  computed: {
    newInformationPointString() {
      return this.points[
        this.pointsArrayOrder[this.pointNum]
      ].pointInformation.replaceAll("\n", "\n");
    },
    audioSrc() {
      if (
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .audioUrl
      ) {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].audioUrl;
      } else {
        return null;
      }
    },
    numberOfQUestionPerPoint() {
      return Math.floor(
        this.$store.getters.questionsShuffled.length /
          (this.$store.getters.points.length - 1)
      );
    },
    lang() {
      // console.log("this.$store.getters.lang", this.$store.getters.lang);
      return this.translate(this.$store.getters.lang);
    },
    userName() {
      return this.$store.getters.user.userName;
    },
    arrayOfAudioUrl() {
      return this.$store.getters.arrayOfAudioUrl;
    },
    arrayOfPointInfo() {
      return this.$store.getters.arrayOfPointInfo;
    },
    mapParameters() {
      return this.$store.getters.mapParameters;
    },
    gameParameters() {
      return this.$store.getters.gameParameters;
    },
    group() {
      return this.$store.getters.group;
    },
    points() {
      return this.$store.getters.points;
    },
    markers() {
      var markers = this.$store.getters.markers;
      var markersArray = [];
      markers.forEach((marker) => {
        markersArray.push({ position: { lat: marker.lat, lng: marker.lng } });
      });
      console.log("markersArray", markersArray);
      return markersArray;
    },
    questions() {
      return this.$store.getters.questions;
    },
    getImgUrl() {
      if (
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .imageBase64
      ) {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].imageBase64;
      } else {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].imageUrl;
      }
    },
    pointsArrayOrder() {
      if (localStorage.getItem("pointsArrayOrder")) {
        return JSON.parse(localStorage.getItem("pointsArrayOrder"));
      } else {
        return this.$store.getters.pointsArrayOrder;
      }
    },
    questionSuffled() {
      // if (localStorage.getItem("questionSuffled")) {
      //   return JSON.parse(localStorage.getItem("questionSuffled"));
      // } else {
      if (localStorage.getItem("questionsArray")) {
        return JSON.parse(localStorage.getItem("questionsArray"));
      } else {
        return this.$store.getters.questionsShuffled;
      }
    },
    getAnswerArray() {
      let answerArray;
      answerArray = [
        this.questionSuffled[this.questionNumber].wrongAnswer1,
        this.questionSuffled[this.questionNumber].wrongAnswer2,
        this.questionSuffled[this.questionNumber].wrongAnswer3,
        this.questionSuffled[this.questionNumber].correctAnswer,
      ];
      let currentIndex = answerArray.length,
        temporaryValue,
        randomIndex;
      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = answerArray[currentIndex];
        answerArray[currentIndex] = answerArray[randomIndex];
        answerArray[randomIndex] = temporaryValue;
      }
      return answerArray;
    },
  },
  methods: {
    reopenGame() {
      if (localStorage.getItem("navigationName")) {
        this.$router.push("/" + localStorage.getItem("navigationName"));
        location.reload();
      } else {
        this.$router.push("/");
        location.reload();
      }
    },
    skipPoint() {
      this.alertSkipPoint = false;
      this.startTime = this.startTime - 60 * 10 * 1000;
      // this.dialogCorrectAnswer = true;
      localStorage.setItem("pointNumberOuchui", this.pointNum);
      localStorage.setItem(
        "pointNumForEvolutionOuchui",
        this.pointNumForEvolution
      );
      // console.log(
      //   "[skipPoint] this.showPointInformation",
      //   this.showPointInformation
      // );
      // console.log(
      //   "[skipPoint] this.rowPhotoMissingWord",
      //   this.rowPhotoMissingWord
      // );

      this.$store.dispatch("addEvolutionToDB", {
        pointNumber: this.pointNum,
        userKey: this.userKey,
        navigationName: this.gameParameters.navigationName,
      });
    },
    showAlertSkipPoint() {
      this.alertSkipPoint = true;
    },
    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      return blob;
    },
    stopLocationUpdates() {
      console.log(
        "stopLocationUpdates clicked this.watchPositionId",
        this.watchPositionId
      );
      this.showPosMarker = false;
      this.showCurrentPositionButton = true;
      navigator.geolocation.clearWatch(this.watchPositionId);
      console.log(
        "stopLocationUpdates clicked this.watchPositionId",
        this.watchPositionId
      );
    },
    showCurrentPosition() {
      if (navigator.geolocation) {
        console.log("navigator.geolocation OK");
        this.showCurrentPositionButton = false;
        this.watchPositionId = navigator.geolocation.watchPosition(
          (position) => {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            // console.log("position", position);
            this.myCurrentPosition = pos;
            // console.log("this.myCurrentPosition", this.myCurrentPosition);
            this.showPosMarker = true;
          },
          () => {
            handleLocationError(true, infoWindow, map.getCenter());
          },
          { enableHighAccuracy: true }
        );
      } else {
        // Browser doesn't support Geolocation
        alert("Browser doesn't support Geolocation");
        // handleLocationError(false, infoWindow, map.getCenter());
      }
    },
    translate(lang) {
      switch (lang) {
        case "fr":
          this.translationMissingWord = "Mot manquant sur l'image";
          this.translation = {
            back: "Fermer",
            skipPoint: "Passer au point suivant",
            skipPointBeware:
              "Attention! Si vous ne trouvez pas la pancarte, vous pouvez passer au point suivant, 10 minutes serons ajoutées à votre temps final.",
            mistakes: "Erreurs",
            runningTime: "Temps écoulé",
            map: "Carte",
            pointNumber: "Sur la carte, repérez le nº",
            goThere:
              "Rendez-vous sur place et trouvez l'inscription qui se trouve sur l'image ci-dessous.",
            didYouKnow: "Le saviez-vous?",
            goToQuestions: "Allons aux questions!",
            wellDone: "Bien joué!",
            correctAnswer: "C'est une bonne réponse!",
            continue: "Allez! On continue",
            wrongAnswer: "Ce n'est pas la bonne réponse.",
            tryAgain: "Essayons encore!",
            visitOf: "Nous espérons que vous avez apprécié votre visite de",
            yourResults: "Vos résultats sont:",
            errorNumber: "Nombre d'erreur:",
            totalTime: "Temps total:",
            goToRanking:
              "Avant de partir, vous pouvez aller jeter un coup d'oeil sur les résultats et voir en quelle positon vous êtes arrivés!",
          };
          break;
        case "en":
          this.translationMissingWord = "Missing word on the picture";
          this.translation = {
            back: "Fermer",
            skipPoint: "Passer au point suivant",
            skipPointBeware:
              "Attention! Si vous ne trouvez pas la pancarte, vous pouvez passer au point suivant, 10 minutes serons ajoutées à votre temps final.",
            mistakes: "Mistakes",
            runningTime: "Elapsed time",
            map: "Map",
            pointNumber: "On the map, find the nº",
            goThere: "Go there, and find this inscription ",
            didYouKnow: "Did you know?",
            goToQuestions: "Go to questions!",
            wellDone: "Well done!",
            correctAnswer: "The answer is correct!",
            continue: "Let’s continue…",
            wrongAnswer: "That's not the correct answer.",
            tryAgain: "Let's try again!",
            visitOf: "We hope you enjoyed your visit of",
            yourResults: "Your results are:",
            errorNumber: "Mistakes:",
            totalTime: "Total time:",
            goToRanking:
              "Before you leave, you can go take a look at the results and see where you are!",
          };

          // code block
          break;
        case "he":
          this.translationMissingWord = "מילה חסרה בתמונה";
          this.translation = {
            back: "לסגור",
            skipPoint: "לעבור לנקודה הבאה",
            skipPointBeware:
              "זהירות! אם אתם לא מוצאים את השלט, אתם יכולים לעבור לנקודה הבאה, 10 דקות יתווספו לזמן הסופי שלכם.",
            mistakes: "טעויות",
            runningTime: "זמן רץ",
            map: "מפה",
            pointNumber: "מצאו במפה את תחנה מספר",
            goThere: "הגיעו למקום והשלימו את המילה החסרה בשלט",
            didYouKnow: "",
            goToQuestions: "לשאלות!",
            wellDone: "יפה מאוד!",
            correctAnswer: "תשובה נכונה!",
            continue: "לחצו להמשך",
            wrongAnswer: "תשובה לא נכונה.",
            tryAgain: "ננסה שוב!",
            visitOf: "מקווים שנהנתם מהמשחק",
            yourResults: "התוצאות שלכם:",
            errorNumber: "טעויות:",
            totalTime: "סה''כ זמן:",
            goToRanking: "לפני שאתם מסיימים, אתם יכולים לראות באיזה מיקום אתם!",
          };
          // code block
          break;
        default:
        // code block
      }
    },
    slideMapInn() {
      document.getElementById("map").className = "showMap";
    },
    removeMap() {
      document.getElementById("map").classList.remove("showMap");
    },
    fadeInDiv() {
      this.showPointInformation = false;
      this.showButtonInfoScreen = false;
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").className = "fadeIn";
      } else {
        console.log("[fadeInDiv] no questionDiv");
      }
    },
    countSeconds() {
      setInterval((_) => {
        this.timeNow = Date.now();
        this.totalSeconds = Math.floor((this.timeNow - this.startTime) / 1000);
        var pad = function (num, size) {
            return ("000" + num).slice(size * -1);
          },
          time = parseFloat(this.totalSeconds).toFixed(3),
          hours = Math.floor(time / 60 / 60),
          minutes = Math.floor(time / 60) % 60,
          seconds = Math.floor(time - minutes * 60);

        this.secondsToTime =
          pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
      }, 1000);
    },
    showResults() {
      // console.log("showResults");
      // localStorage.clear();
      this.$router.push("/results");
      // this.$store.dispatch("getResults", this.gameParameters.navigationName);
    },
    checkMissingWord() {
      if (
        this.missingWordAnswer.toLowerCase() ===
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .missingWord
      ) {
        this.dialogCorrectAnswer = true;
      } else {
        this.dialogWrongAnswer = true;
        this.errorNumber++;
        localStorage.setItem("errorNumber", this.errorNumber);
      }
    },
    checkAnswer(answer) {
      if (this.answered) return;
      this.answered = true;
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").classList.remove("fadeIn");
      } else {
        console.log("[checkAnswer] No questionDiv");
      }
      if (answer === this.questionSuffled[this.questionNumber].correctAnswer) {
        if (
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber == this.gameParameters.lastPoint
        ) {
          this.showLastDialog = true;
          // GET THE TOTAL TIME OF THE GAME
          this.endTime = Date.now();
          this.gameTimeInSecond = Math.floor(
            (this.endTime - this.startTime) / 1000
          );
          var pad = function (num, size) {
              return ("000" + num).slice(size * -1);
            },
            time = parseFloat(this.gameTimeInSecond).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);

          this.gameSecondToTime =
            pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
          // SEND THE RESULTS TO THE DATABASE
          console.log("[checkAnswer] B4 checkResults");
          this.$store.dispatch("checkResults", {
            errorNumber: this.errorNumber,
            gameSecondToTime: this.gameSecondToTime,
            gameTimeInSecond: this.gameTimeInSecond,
          });
        } else {
          this.dialogCorrectAnswer = true;
        }
      } else {
        this.dialogWrongAnswer = true;
        this.errorNumber++;
        localStorage.setItem("errorNumber", this.errorNumber);
      }
    },
    hideImageQuestion() {
      // console.log("[hideImageQuestion] this.starttime", this.startTime);
      localStorage.setItem("startTimeOuchui", this.startTime);
      // ADD A FADEINN CLASS TO THE QUESTION DIV
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").className = "fadeIn";
      } else {
      }
      // Here I check if I need to show the Information Page as per the game parameters
      this.dialogCorrectAnswer = false;
      this.answered = false;
      if (this.gameParameters.infoPage == true && this.firstQuestion == 1) {
        this.showPointInformation = true;
        setTimeout((_) => {
          this.showButtonInfoScreen = true;
        }, 3000);
      }
      this.missingWordAnswer = "";
      // ***********************************************ADDED THIS JUST FOR THE RANDOM QUESTIONS
      if (this.gameParameters.randomQuestions === true) {
        if (this.firstQuestion < this.numberOfQUestionPerPoint + 1) {
          this.questionNumber++;
          localStorage.setItem("questionNumber", this.questionNumber);
          // console.log("this.firstQuestion", this.firstQuestion)
          this.firstQuestion++;
          localStorage.setItem("firstQuestion", this.firstQuestion);
          // console.log("this.firstQuestion", this.firstQuestion)
          this.rowPhotoMissingWord = false;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
        } else {
          localStorage.setItem("questionNumber", this.questionNumber);
          this.rowPhotoMissingWord = !this.rowPhotoMissingWord;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);

          if (this.rowPhotoMissingWord) {
            this.pointNum++;
            this.pointNumForEvolution++;
            localStorage.setItem("pointNumberOuchui", this.pointNum);
            localStorage.setItem(
              "pointNumForEvolutionOuchui",
              this.pointNumForEvolution
            );
            this.$store.dispatch("addEvolutionToDB", {
              pointNumber: this.pointNum,
              userKey: this.userKey,
              navigationName: this.gameParameters.navigationName,
            });
            this.firstQuestion = 1;
            localStorage.setItem("firstQuestion", 1);
          }
        }
      } else {
        // ******************************************************************************************

        console.log(
          " this.questionSuffled[this.questionNumber + 1].pointLinked",
          this.questionSuffled[this.questionNumber + 1].pointLinked
        );
        console.log(
          " Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1].pointNumber",
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber
        );
        if (
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber ==
          this.questionSuffled[this.questionNumber + 1].pointLinked
        ) {
          this.questionNumber++;
          localStorage.setItem("questionNumber", this.questionNumber);

          this.firstQuestion++;
          localStorage.setItem("firstQuestion", this.firstQuestion);

          this.rowPhotoMissingWord = false;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
        } else {
          localStorage.setItem("questionNumber", this.questionNumber);
          this.rowPhotoMissingWord = !this.rowPhotoMissingWord;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);

          if (this.rowPhotoMissingWord) {
            this.pointNum++;
            this.pointNumForEvolution++;
            localStorage.setItem("pointNumberOuchui", this.pointNum);
            localStorage.setItem(
              "pointNumForEvolutionOuchui",
              this.pointNumForEvolution
            );

            this.$store.dispatch("addEvolutionToDB", {
              pointNumber: this.pointNum,
              userKey: this.userKey,
              navigationName: this.gameParameters.navigationName,
            });
            this.firstQuestion = 1;
            localStorage.setItem("firstQuestion", 1);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.removeMapButton {
  position: absolute;
  top: 6px;
  font-size: 53px;
  z-index: 100;
  right: 8px;
}
.removeMapButton button {
  font-size: 48px;
  color: black;
  height: 55px;
  width: 55px;
  border-radius: 100%;
  background: rgb(249 248 248);
  padding-bottom: 4px;
  border: solid 3px red;
}
.mainButton {
  border-radius: 50px;
  height: 56px;
  color: white !important;
  display: block;
  margin: 0px auto;
  height: 90px !important;
  width: 90px;
  border: solid darkgreen 2px;
}
.currentPosButton {
  position: absolute;
  top: 61px;
  font-size: 19px;
  z-index: 100;
  color: green;
  left: 11px;
  direction: rtl;
  font-family: noot;
  background: white;
  border: 1px solid green;
  padding: 7px 8px 0px;
  border-radius: 5px;
}
#erreurs {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 28px);
}
#evolution {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 35px);
}
#runningTime {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 13px);
}
#carte {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 6px);
}

.center {
  display: block;
  margin: 0px auto;
}
#mapButton {
  width: 30px;
  position: absolute;
  top: 4px;
  right: -10px;
  margin-right: calc(50vw - 155px);
  font-size: 25px;
  color: white;
  /* border: solid 1px black; */
  width: 42px;
  height: 40px;
  padding: 5px;
  /* background: white; */
  z-index: 5;
}
#map {
  position: fixed;
  top: -100vh;
  right: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  overflow: hidden;
  transition: all 1s;
}
.showMap {
  position: fixed;
  top: 0 !important;
  right: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  overflow: hidden !important;
  transition: all 1s;
}

#imgUrl {
  display: block;
  margin: 0 auto;
}
.errorsTimeMap {
  background: rgba(255, 255, 255, 1);
  border: none;
  font-size: 20px;
  padding-top: 5px;
}
.errorsTimeMap > svg {
  position: relative;
  bottom: 3px;
}
.pointNumber {
  margin: 0 auto;
  border: #d41a1b solid 2px;
  border-radius: 100px;
  height: 55px;
  width: 55px;
  font-size: 36px;
  padding-right: 1px;
  padding-top: 4px;
}
.rtl {
  direction: rtl;
}
.verticalAlign {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 80%;
}
.myModal {
  height: auto;
  min-height: 200px;
  width: 300px;
  border-radius: 10px;
  display: flex;
  color: white;
}
.modalInformationPoint {
  box-shadow: none;
  border: solid rgb(228 255 3) 5px;
  margin-top: 1vh;
  width: 98vw;
  font-size: 22px;
  height: auto;
  overflow: auto;
  background: #00bfc2;
  color: white;
  overflow: scroll;
  max-height: 98vh;
}
.red {
  background-color: #d41a1b;
  border: solid white 2px;
}
.green {
  background-color: rgb(119, 190, 87);
  border: 2px white solid;
}
.over {
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 3;
  display: flex;
  justify-content: center;
}
.colorBtn {
  border-radius: 36px;
  min-height: 56px;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.question {
  text-align: center;
  font-family: "Assistant", sans-serif;
  font-weight: 400;
  font-size: 22px;
  color: black;
}
.btnAnswer {
  margin: 0 auto;
  width: 320px;
  height: 60px;
  border-radius: 35px;
  font-size: 20px;
  color: white;
  background: rgb(64, 150, 83) !important;
}
.title {
  font-size: 25px;
  text-align: right;
  color: black;
}
.userName {
  font-size: 18px;
  text-align: left;
  color: black;
}
.time {
  letter-spacing: 0.05em;
  font-size: 24px;
  font-family: "Cabin", sans-serif;
  text-align: center;
  color: rgb(14, 15, 14, 0.8);
}
.startTime {
  letter-spacing: 0.05em;
  font-size: 40px;
  padding: 5px 0;
  font-family: "Inconsolata", monospace;
  color: #ffffff;
  text-align: center;
  position: relative;
  left: 50%;
  margin-top: 50px;
  top: -24px;
  transform: translate(-50%, -50%);
  color: #daf6ff;
}
.hebrewText {
  text-align: right;
  font-size: 15px;
  padding-right: 5px;
  color: black;
}

.fadeIn {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
}

.confetti {
  top: 0px;
  width: 15px;
  height: 15px;
  background-color: #b1f70f;
  position: absolute;
  left: 50%;
  animation: confetti 5s ease-in-out -2s infinite;
  transform-origin: left top;
}
.confetti:nth-child(1) {
  background-color: #faf623;
  left: 10%;
  animation-delay: 0;
}
.confetti:nth-child(2) {
  background-color: #129dee;
  left: 20%;
  animation-delay: -5s;
}
.confetti:nth-child(3) {
  background-color: #e21f0d;
  left: 30%;
  animation-delay: -3s;
}
.confetti:nth-child(4) {
  background-color: #f1dc6f;
  left: 40%;
  animation-delay: -2.5s;
}
.confetti:nth-child(5) {
  background-color: #039cf5;
  left: 50%;
  animation-delay: -4s;
}
.confetti:nth-child(6) {
  background-color: #f52916;
  left: 60%;
  animation-delay: -6s;
}
.confetti:nth-child(7) {
  background-color: #5cf24e;
  left: 70%;
  animation-delay: -1.5s;
}
.confetti:nth-child(8) {
  background-color: #d717e9;
  left: 80%;
  animation-delay: -2s;
}
.confetti:nth-child(9) {
  background-color: #f30e34;
  left: 90%;
  animation-delay: -3.5s;
}
.confetti:nth-child(10) {
  background-color: #7cf24e;
  left: 100%;
  animation-delay: -2.5s;
}
.confetti:nth-child(11) {
  background-color: #f52916;
  left: 15%;
  animation-delay: -6.5s;
}
.confetti:nth-child(12) {
  background-color: #5cf24e;
  left: 25%;
  animation-delay: -1.8s;
}
.confetti:nth-child(13) {
  background-color: #d717e9;
  left: 75%;
  animation-delay: -2.5s;
}
.confetti:nth-child(14) {
  background-color: #f30e34;
  left: 85%;
  animation-delay: -3.8s;
}
.confetti:nth-child(15) {
  background-color: #7cf24e;
  left: 55%;
  animation-delay: -4.2s;
}
.confetti:nth-child(16) {
  background-color: #d717e9;
  left: 75%;
  animation-delay: -3.5s;
}
.confetti:nth-child(18) {
  background-color: #f30e34;
  left: 85%;
  animation-delay: -6.8s;
}
.confetti:nth-child(17) {
  background-color: #7cf24e;
  left: 55%;
  animation-delay: -4.9s;
}

@keyframes confetti {
  0% {
    transform: rotateZ(15deg) rotateY(0deg) translate(0, 0);
  }
  25% {
    transform: rotateZ(5deg) rotateY(360deg) translate(-5vw, 20vh);
  }
  50% {
    transform: rotateZ(15deg) rotateY(720deg) translate(7vw, 60vh);
  }
  75% {
    transform: rotateZ(5deg) rotateY(1080deg) translate(-25vw, 80vh);
  }
  100% {
    transform: rotateZ(15deg) rotateY(1440deg) translate(20vw, 110vh);
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@font-face {
  font-family: noot;
  src: url(../../static/fonts/Noot/noot-aj.woff);
}
</style>
